const useGetUserAgent = (userAgent: string): boolean => {
  return navigator.userAgent.indexOf(userAgent) !== -1
}

export default useGetUserAgent
